import React from 'react';

import cn from 'classnames';

import Message from 'components/Message';
import Typography from 'components/Typography';

import { IntlMsgShape } from 'helpers/consts';

export type BadgeVariants = 'hot' | 'new';

interface IProps {
  variant: BadgeVariants;
  titleOverride?: IntlMsgShape | string;
}

const Badge = ({ variant, titleOverride }: IProps) => {
  const isHot = variant === 'hot';

  return (
    <div
      className={cn(
        'Badge ml-0.5 flex h-5 items-center rounded-2xl px-2',
        isHot ? 'Badge--hot bg-primary' : 'Badge--new bg-acid',
      )}
    >
      <Typography variant="small-thick" color={isHot ? 'white' : 'dark-body'}>
        <Message
          message={titleOverride || { id: `components.Badge.${variant}` }}
        />
      </Typography>
    </div>
  );
};

export default Badge;
